import React from "react";
// import $ from 'jquery' 
// import Fa from 'react-fontawesome'

export default class FaqPage extends React.Component {

  render() {
    return (
      <div>

FaqPage

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FaqPage.js